module.exports = __webpack_public_path__ + "img/link.ab568a94.svg";